import React from "react";
import "./LoadingScreen.css";

const LoadingScreen = ({ message }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-squares">
        {[...Array(4)].map((_, i) => (
          <div key={i} className={`square square${i + 1}`}></div>
        ))}
      </div>
      <div className="loading-message">{message}</div>
    </div>
  );
};

export default LoadingScreen;